import { render, staticRenderFns } from "./costAllocationModal.vue?vue&type=template&id=5bc24bba&scoped=true"
import script from "./costAllocationModal.vue?vue&type=script&lang=js"
export * from "./costAllocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc24bba",
  null
  
)

export default component.exports